import { insertAt } from '~/utils/array'

const DEAL_LIST_TENANCY_POSITIONS = [1, 2, 4]

const filterAndSortTenancies = (tenancies) =>
  tenancies
    .filter(({ position: { position } }) => DEAL_LIST_TENANCY_POSITIONS.includes(position))
    .sort(({ position: { position: a } }, { position: { position: b } }) => a - b)

const combineTenanciesWithDeals = (deals, t) => {
  const tenancy = { ...t, isSponsored: true }
  const position = t?.position?.position || t?.deal?.position?.position

  return position > deals.length ? [...deals, tenancy] : insertAt(position - 1, deals, tenancy)
}

export const insertTenanciesIntoDealsList = ({
  deals,
  tenancies,
  renderDeal,
  renderTenancy,
  renderPriceRiseBanner = null
}) => {
  const tenanciesToInclude = filterAndSortTenancies(tenancies)

  const dealsWithRender = deals.map((deal) => ({ deal, render: renderDeal }))
  const tenanciesWithRender = tenanciesToInclude.map((deal) => ({ deal, render: renderTenancy }))

  const allDeals = tenanciesToInclude.reduce(combineTenanciesWithDeals, deals)
  const allDealsRendered = tenanciesWithRender
    .reduce(combineTenanciesWithDeals, dealsWithRender)
    .map(({ deal, render }, idx) => render(deal, idx))

  if (renderPriceRiseBanner) {
    // Insert <PriceRiseBanner /> into the deals list at position 5
    allDealsRendered.splice(4, 0, renderPriceRiseBanner())
  }

  return { allDeals, allDealsRendered }
}
